export default () => {
  const init = () => {
    class ResponsiveIframe extends HTMLElement {
      constructor() {
        super();

        const iframes = this.querySelectorAll('iframe');

        iframes.forEach((iframe) => {
          this.wrapThis(iframe);
        });
      }

      wrapThis(iframe) {
        const aspectRatio = iframe.height / iframe.width;
        const wrapper = document.createElement('div');

        wrapper.classList.add('responsive-iframe');
        wrapper.style.setProperty('--aspect-ratio', aspectRatio);

        iframe.parentNode.insertBefore(wrapper, iframe);

        wrapper.appendChild(iframe);
      }
    }

    customElements.define('responsive-iframe', ResponsiveIframe);
  };

  init();
};